module.exports = __webpack_public_path__ + "img/icon_close.5bf0200d.svg";